import { IPromocode } from "../../types";

/**
 * Formats the display name for a voucher based on its type
 * 
 * @param voucher - The promocode object
 * @param currency - The currency symbol/code to use for value-based discounts
 * @returns Formatted display text for the voucher
 */
export const formatVoucherDisplayName = (
    voucher: IPromocode,
    currency: string
): string => {
    if (!voucher) return "";

    switch (voucher.type) {
        case "discount_percentage":
            // Convert decimal to percentage (e.g., 0.7 -> 70%)
            const percentValue = Math.round(voucher.discount_value * 100);
            return `${percentValue}% Promocode`;

        case "discount_value":
            return `${voucher.discount_value} ${currency} OFF`;

        case "cashback_percentage":
            // Convert decimal to percentage (e.g., 0.07 -> 7%)
            const cashbackPercent = Math.round((voucher.cashback_value ?? 0) * 100);
            return `${cashbackPercent}% Cashback`;

        default:
            // Fallback to a generic display if type is unknown
            return `${voucher.promo_code || "Promocode"}`;
    }
};